<template>
    <div class="w-full flex flex-row justify-center home-text-outer-container bg-themeComponentBg-light font-rubik">
      <div class="w-full max-w-1024 mx-5">
        <div class="home-text-inner-container">
          <h1 class="mb-4 home-text-h1">
            Why Container Alliance?
          </h1>
          <p class="home-text-p">
            We know you have a lot of choices when looking for a storage container company,
            but we stand apart from the rest for a number of reasons. As the largest network
            of providers in North America, we provide you with virtually limitless options
            to meet your specifications. No other moving container company has as much
            expertise and knowledge as we do, meaning you can count on us to provide you with
            the exact solution you need.
          </p>
          <br>
          <p class="home-text-p">
            We’re also flexible, providing rentals or sales so you don’t have to worry about
            being locked into a long-term arrangement when you only need a temporary boost in
            capacity. If you need a custom shipping container for your business, it’s no problem.
            We have a team of modification experts who are ready and willing to help you transform
            your container into whatever you want, whether it’s an office, a kitchen, a demo
            booth, or something else.
          </p>
          <br>
          <p class="home-text-p">
            We work nationwide, with containers available in every major metropolitan area across
            the country. Even though we offer services on a national scale, you can still expect
            the dependability and customer service you would normally only expect from a smaller
            company.
          </p>
        </div>
      </div>
    </div>
</template>

<script>
//improve search engine optimization
export default {
  mounted() {
    try {
      const ld = {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        'headline': document.querySelector('.home-text-h1')?.innerText || document.title,
        'description': Array.from(document.querySelectorAll('.home-text-p')).map(p => p.innerText).join(' '),
        'url': window.location.href,
        'publisher': { '@type': 'Organization', 'name': 'Container Alliance' }
      }
      const script = document.createElement('script')
      script.type = 'application/ld+json'
      script.text = JSON.stringify(ld)
      document.head.appendChild(script)
    } catch (e) {
      console.warn('Error injecting JSON-LD:', e)
    }
  }
}
</script>

<style scoped>
.home-text-h1{
  font-size: 48px;
  font-weight: 400;
  line-height: 57.6px;
  letter-spacing: -0.04em;
  text-align: left;
  color: black;
}

.home-text-p {
  color: black;
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
  text-align: left;
}

.home-text-inner-container {
  width: 715px;
}

.home-text-outer-container {
  padding-top: 112px;
}

/* mobile */
@media(max-width: 1240px) {
  .home-text-outer-container {
    padding-top: 24px;
  }

  .home-text-inner-container {
    width: 100%;
  }

  .home-text-h1{
    font-size: 36px;   
  }

  .home-text-p {
    font-size: 14px;
    line-height: 15px;
  }
}
</style>